export default {"src":"/_next/static/media/0xdd629e5241cbc5919847783e6c96b2de4754e438.8a363edb.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};